<template>
  <div>
    <div class="bg-navbar backdrop-blur-sm w-full px-1.5" id="bar">
      <p class="sm:container text-gray-dark text-md pt-2">Prodotti</p>
    </div>
    <div class="bg-navbar backdrop-blur-sm z-10 text-gray-dark text-xs md:text-sm p-1.5 space-x-3 w-full" id="header">
      <div class="flex flex-col space-y-1.5 w-full sm:container">
        <div class="flex w-full items-center space-x-2">
          <button v-if="order_id" @click="go_order" class="text-md text-gray-dark cursor-pointer hover:text-primary"><i
              class="fa-light fa-arrow-left"></i></button>
          <div class="flex flex-grow bg-gray-light items-center pr-1 space-x-1 rounded-xl">
            <input class="border-0 bg-gray-light" placeholder="Cerca SKU" type="search" v-model="search"
                   @change="select_search()">
            <i class="fa-light  rounded-xl pr-1 fa-magnifying-glass cursor-pointer"></i>
          </div>
          <p class="text-base text-gray-dark cursor-pointer mr-2 hover:text-primary" @click="$refs.filter.open()"><i
              class="fa-light  fa-filter"></i></p>
        </div>
        <Transition
            enter-active-class="duration-300 ease-in-out"
            enter-from-class="transform-all opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="transform-all opacity-0"
        >
        <div v-if="wishlist === 'true' || (node && node.name)"
             class="flex space-x-2 order-2 lg:order-1 overflow-hidden">
          <div class="title flex text-muted space-x-1 overflow-y-auto w-full items-center"
               style="scrollbar-width: none;">
            <span @click="construct.query.wishlist = false; changeNode({id: null})"
                  class="cursor-pointer whitespace-nowrap leading-none transition hover:text-secondary-dark"><i
                class="fa-light fa-house"></i></span>
            <span>/</span>
            <span v-if="wishlist === 'true'" class="text-primary whitespace-nowrap">Lista Prenotazioni</span>
            <template  v-else-if="node">
              <template v-for="(n,index) in node.full_path">
                                    <span v-if="index !== (node.full_path.length -1)"
                                          class="cursor-pointer whitespace-nowrap leading-none transition hover:text-secondary-dark"
                                          @click="changeNode(n)">{{ n.name }}</span>
                <span v-if="index !== (node.full_path.length -1)">/</span>
              </template>
              <h1 class="text-primary whitespace-nowrap">{{ node.name }}</h1>
            </template>
          </div>
        </div>
        </Transition>
        <Transition
            enter-active-class="duration-300 ease-in-out"
            enter-from-class="transform-all opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="transform-all opacity-0"
        >
          <div
              v-if="tags || searched || filters.new || filters.promo || products_bought || selected_specs.length"
              class="flex flex-wrap space-x-2">
            <TransitionGroup
                enter-active-class="duration-300 ease-in-out"
                enter-from-class="transform-all opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="transform-all opacity-0"
            >
              <span v-if="searched" @click="remove_searched()"
                    class="bg-gray-light py-1 px-1.5 rounded-xl text-gray-dark space-x-1 cursor-pointer"><i
                  class="fa-light  fa-xmark"></i> {{
                  searched
                }} </span>
              <span v-if="filters.promo" id="promo" @click="filters.promo = false"
                    class="bg-gray-light py-1 px-1.5 rounded-xl text-gray-dark space-x-1 cursor-pointer"><i
                  class="fa-light  fa-xmark"></i> Promo </span>
              <span v-if="filters.new" id="new" @click="filters.new = false"
                    class="bg-gray-light py-1 px-1.5 rounded-xl text-gray-dark space-x-1 cursor-pointer"><i
                  class="fa-light  fa-xmark"></i> Novità </span>
              <span v-for="tag in tags" :id="tag.spec_id" @click="removeSpec(tag.spec_id, tag.value, tag.type)"
                    class="bg-gray-light py-1 px-1.5 rounded-xl text-gray-dark space-x-1 cursor-pointer">
                     <i class="fa-light  fa-xmark"></i> {{ tag.spec_name }}: {{ tag.name }} </span>

            </TransitionGroup>
          </div>
        </Transition>
      </div>
    </div>

    <div class="container p-2">
      <Transition v-if="!filters.new && !filters.promo"
                  enter-active-class="duration-300 ease-in-out"
                  enter-from-class="transform-all opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="duration-100 ease-in"
                  leave-from-class="opacity-100"
                  leave-to-class="transform-all opacity-0"
      >
        <div class="w-full mb-3">
          <div v-if="order_id && wishlist !=='true' && !(node) && !loading" class="flex justify-center my-2">
            <div @click="construct.query.wishlist = true; refresh(false);" class="p-2 bg-primary text-white rounded-xl">Lista Prenotazioni</div>
          </div>
          <div
              class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-1 md:gap-2">
            <TransitionGroup
                enter-active-class="duration-700 ease-in-out"
                enter-from-class="transform-all opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="transform-all opacity-0"
            >
              <div v-for="n in nodes" @click="changeNode(n)"
                   class="flex bg-white group/item rounded-xl" :class="products && products.length ? 'h-[5rem] justify-between items-center pr-1 md:pr-2 w-full gap-x-1 md:gap-x-2 cursor-pointer' : 'min-h-[5rem] flex-col items-center justify-center'"
                   :key="n.id">
                <div :class="products && products.length ? 'flex items-center space-x-1 overflow-hidden h-full' : 'flex flex-col space-y-1 items-center'">
                  <div v-if="n.image"
                       class="transition-transform overflow-hidden aspect-square" :class="products && products.length ? 'rounded-l-xl h-full' : 'w-full'">
                    <img :src="n.image" alt="" class="h-full aspect-square">
                  </div>
                  <span
                      class="transition-transform text-title pl-2 group-hover/item:-translate-y-1 flex flex-col"
                      style="font-size:1rem; line-height: 1rem">
                                                <span class="text-primary/50"
                                                      v-if="n.key_components && n.key_components.length >= 2">
                                                    {{ n.key_components.at(-2) }}
                                                </span>
                                                <span class="text-xs">{{ n.name }}</span>
                                            </span>
                </div>
                <div v-if="n._hits"
                     class="bg-gray-lighter text-primary text-xs text-center rounded px-1.5 py-1">
                  {{
                    n._hits
                  }}
                </div>
              </div>
            </TransitionGroup>
          </div>
        </div>
      </Transition>
      <div class="relative grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2" id="products"
           ref="products">
        <TransitionGroup
            enter-active-class="duration-700 ease-in-out"
            enter-from-class="transform-all opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="transform-all opacity-0"
        >
          <div v-if="products && products.length" v-for="product in products"
               class="w-full" :key="product.id">
            <product-card :product="product" :order_id="order_id" :key="product.id"></product-card>
          </div>
        </TransitionGroup>
        <div v-if="loading" class="col-span-full flex justify-center items-center pt-0.5 pb-2">
          <div class="flex justify-center items-center h-4 w-4 rounded-full">
            <p class="text-primary"><i class="fa-light fa-spinner-third animate-spin"></i></p>
          </div>
        </div>
      </div>
    </div>
    <slideover ref="filter" title="Filtri">
      <template v-slot:content>
        <div class="flex items-center">
          <input type="checkbox" @change="filters['new'] = !filters['new']"
                 :checked="filters['new']" id="new" class="h-[1.5rem] w-[1.5rem]">
          <label for="new" class="mb-0 ml-1 text-gray-dark text-base">Novità</label>
        </div>
        <div class="flex items-center mt-1.5">
          <input type="checkbox" @change="filters['promo'] = !filters['promo']"
                 :checked="filters['promo']" id="promo" class="h-[1.5rem] w-[1.5rem]">
          <label for="promo" class="mb-0 ml-1 text-gray-dark text-base">Prodotti in promozione</label>
        </div>
        <div v-if="Object.keys(specs).length && products && products.length" class="py-2">
          <p class="text-lg text-gray-dark">Specifiche</p>
          <template v-for="(spec, index) in specs">
            <filter-component v-if="spec && spec.values && Object.keys(spec.values).length"
                              :open="index < 4" :spec="spec" :selected_specs="selected_specs" :key="spec.id"
                              :changeSpecs="changeSpecs" :getSpec="getSpec"
                              :loading="loading"/>
          </template>

          <!--          <component v-for="spec in specs" :key="spec.id"
                               :is="spec.component || 'simple'" :id="spec.id"
                               :values="spec.values" :name="spec.name" :description="spec.description"
                               :icon="spec.icon"
                               :changeSpecs="changeSpecs" :getSpec="getSpec" :loading="loading"></component>-->
        </div>
      </template>
    </slideover>
    <navbar v-if="!order_id"></navbar>
  </div>
</template>

<script>
import navbar from "../../components/navbar.vue";
import ProductCard from "./product-card.vue";
import Slideover from "../../components/slideover.vue";
import FilterComponent from "./components/filter-component.vue";

export default {
  name: "product-index",
  components: {FilterComponent, Slideover, ProductCard, navbar},

  props: {
    node_id: null,
    searched_product: null,
    products_bought: false,
    order_id: null,
    from: null,
    sp: null,
    wishlist: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    products: [],
    currentPage: 1,
    lastPage: 1,
    node: null,
    nodes: [],
    search: null,
    searched: null,
    loading: true,
    filters: {
      promo: false,
      new: false
    },
    construct: {
      name: 'products.index',
      params: {},
      query: {
        sp: {},
      }
    },
    specs: [],
    tags: [],
    selected_specs: {}
  }),
  methods: {
    changeSpecs: function (spec_id, value) {
      if (Object.keys(value).length)
        this.selected_specs[spec_id] = value;
      else delete this.selected_specs[spec_id];
      this.currentPage = 1;
      this.load_products(true, true);
    },
    getSpec(spec_id) {
      return this.selected_specs && this.selected_specs[spec_id] ? JSON.parse(JSON.stringify(this.selected_specs[spec_id])) : [];
    },
    removeSpec(spec_id, val, type='simple') {
      if(type === 'simple') {
        let arr = this.getSpec(spec_id);
        let index = arr.indexOf(val);
        arr.splice(index, 1);
        this.changeSpecs(spec_id, arr, true);
      }else this.changeSpecs(spec_id, {}, true);

    },
    async load() {
      if(Object.keys(this.construct.query.sp).length) this.selected_specs = JSON.parse(atob(this.construct.query.sp));
      this.specs = {};
      this.lastPage = 1;
      this.currentPage = 1;
      this.products = [];
      if (this.$props.searched_product)
        this.searched = this.unslug(this.$props.searched_product);
      await this.load_products();
    },
    async load_products(loading = true, refresh = false) {
      this.loading = true;
      let data = (await axios.get('/prodotti/products', {
        params: {
          node_id: this.node_id,
          search: this.searched,
          page: this.currentPage,
          order_id: this.$props.order_id,
          promo: this.filters.promo,
          new: this.filters.new,
          products_bought: this.products_bought,
          specs: this.selected_specs,
          wishlist: this.wishlist
        }
      })).data;
      if (data.products && data.current_page !== 1 && !refresh)
        data.products.forEach(v => this.products.push(v));
      else this.products = data.products;
      this.nodes = data.nodes;
      this.node = data.node;
      this.lastPage = data.last_page;
      this.specs = data.specifications;
      this.tags = data.tags;
      this.loading = false;
    },
    changeNode(n) {
      this.construct.params.node_id = n.id;
      this.refresh(false);
    },
    select_search() {
      this.searched = this.search;
      this.construct.query.searched_product = this.searched;
      this.refresh();
    },
    remove_searched() {
      delete this.construct.query.searched_product;
      this.searched = null;
      this.search = null;
      this.refresh()
    },
    change_promo() {
      this.currentPage = 1;
      this.lastPage = 1;
      this.load_products(true, true);
    },
    change_new() {
      this.currentPage = 1;
      this.lastPage = 1;
      this.load_products(true, true);
    },
    refresh(push = false) {
      window.scrollTo(0, 0);
      this.construct.query.sp = btoa(JSON.stringify(this.selected_specs));
      if (!push) this.$router.replace(this.construct);
      else this.$router.push(this.construct);
    },
    loadScrolling() {
      let header = document.getElementById('header');
      let sticky = header.offsetTop;
      let bar = document.getElementById('bar');
      window.onscroll = () => {
        if (window.pageYOffset > sticky) {
          header.classList.add('sticky');
          header.classList.add('top-0');
          bar.classList.remove('top-0');
        } else {
          bar.classList.add('top-0');
          header.classList.remove('sticky');
          header.classList.remove('top-0');
        }
        let productsList = this.$refs.products.getBoundingClientRect();
        let bottomOfWindow = productsList.bottom < window.innerHeight;
        let page = this.currentPage + 1;
        if (bottomOfWindow && (page <= this.lastPage) && !this.loading) {
          this.currentPage++;
          this.load_products();
        }
      }
    },
    slug(str) {
      return str.replaceAll(' ', '-');
    },
    unslug(str) {
      return str.replaceAll('-', ' ');
    },
    go_order() {
      if (!this.from) this.$router.replace({name: 'orders.index'});
      else this.$router.replace({name: 'customers.orders', params: {id: this.from}});
      this.$router.replace({name: 'orders.edit', params: {id: this.order_id}});
    },
    initiate_construct() {
      if (this.node_id) this.construct.params.node_id = this.node_id;
      if (this.order_id) this.construct.query.order_id = this.order_id;
      if (this.$props.products_bought) this.construct.query.products_bought = "true";
      if (this.$props.searched_product) this.construct.query.searched_product = this.$props.searched_product;
      if(this.sp) this.construct.query.sp = this.sp;
    }
  },
  mounted() {
    this.initiate_construct();
    this.load();
    this.loadScrolling();
    this.$watch('searched_product', this.load);
    this.$watch('filters.new', this.change_new);
    this.$watch('filters.promo', this.change_promo);
    this.$watch('products_bought', this.load);
  },
  beforeDestroy() {
    window.onscroll = () => null;
  },
  beforeUnmount() {
    window.onscroll = () => null;
  },
}
</script>

<style scoped>

</style>
